// extracted by mini-css-extract-plugin
var _1 = "P38ZxsTQ";
var _2 = "P38ZxsTQ";
export { _1 as "white-background", _2 as "whiteBackground" }
